<template>
  <header class="page-header">
    <div class="row">
      <div class="col-sm-8 header-row">
        <a tabindex="0" href="/" class="page-header__logo">
          <GfuLogo />
        </a>
        <h1 class="page-header__title">{{ $t("navigation.heading") }}</h1>
      </div>
      <div class="col-sm-4">
        <div class="d-flex button-container justify-content-end">
          <!-- <div :class="['btn', 'btn-secondary', 'me-1', {'active': $i18n.locale === 'la'}]" @click="$i18n.locale = 'la'">
            {{ $t('navigation.language.labels') }}
          </div> -->
          <div
            tabindex="0"
            :class="[
              'btn',
              'btn-secondary',
              'me-1',
              { active: $i18n.locale === 'en' },
            ]"
            @click="$i18n.locale = 'en'" 
            @keydown="(event) => handleKeydown(event, 'en')" 
          >                                               <!-- Keyboard handler for activating the div with 'Enter' or 'Space' keys -->
            <span class="flag-icon flag-icon-gb"></span>
            {{ $t("navigation.language.english") }}
          </div>
          <div
              tabindex="0"
              :class="['btn', 'btn-secondary', { active: $i18n.locale === 'de' }]"
              @click="$i18n.locale = 'de'"
              @keydown="(event) => handleKeydown(event, 'de')"
            >
              <span class="flag-icon flag-icon-de"></span>
              {{ $t("navigation.language.german") }}
          </div> 
        </div>
        <!-- <div>Selected: {{ $i18n.locale === 'en' ? $t('english') : $t('german') }}</div> -->
      </div>
    </div>

    <div class="row" v-if="$route.name === 'RoomList'">
      <div class="col-sm-12">
        <div class="page-header__content">
          <blockquote>
            <p v-html="$t('rooms.header.quote')"></p>
            <small>{{ $t("rooms.header.author") }}</small>
          </blockquote>
          <p v-html="$t('rooms.header.conclusion')"></p>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-sm-12" v-if="seminarDate.seminar">
        <div class="page-header__content">
          <h2>
            {{ $t("ratingForm.header.label") }}: <br />
            <span class="course-title">{{
              seminarDate.alternativeTitle
                ? seminarDate.alternativeTitle
                : seminarDate.seminar.title
            }}</span>
          </h2>
          <ul class="page-header__meta">
            <li>
              <font-awesome-icon
                icon="fa-graduation-cap"
                class="header-icon-style"
                aria-hidden="true"
              />
              <span class="course-trainer"
                >{{ seminarDate.trainers[0].contact.firstName }}
                {{ seminarDate.trainers[0].contact.lastName }}</span
              >
            </li>
            <li>
              <font-awesome-icon
                icon="fa-location-dot"
                class="header-icon-style"
                aria-hidden="true"
              />
              <span class="course-room"
                >{{ $t("common.room") }}:
                {{
                  seminarDate.rooms[0]
                    ? seminarDate.rooms[0].shortName
                    : $t("ext")
                }}</span
              >
            </li>
            <li>
              <font-awesome-icon
                class="header-icon-style"
                icon="fa-regular fa-calendar"
                aria-hidden="true"
              />
              <span class="course-date">{{
                getDate(seminarDate.start, seminarDate.duration)
              }}</span>
            </li>
            <li>
              <font-awesome-icon
                class="header-icon-style"
                icon="fa-regular fa-clock"
                aria-hidden="true"
              />
              <span class="course-duration"
                >{{ seminarDate.duration }}
                {{
                  seminarDate.duration > 1
                    ? $t("common.unitDayPl")
                    : $t("common.unitDay")
                }}</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import GfuLogo from "../GfuLogo.vue";
import { mapGetters } from "vuex";

export default {
  name: "Header",
  components: {
    GfuLogo,
  },
  computed: {
    ...mapGetters(["seminarDate"]),
  },
  methods: {
    getDate(start, duration) {
      const startDate = new Date(start);
      const endDate = new Date(start);
      const lanCode = this.$i18n.locale === "en" ? "en-GB" : "de-DE";
      endDate.setDate(endDate.getDate() + (duration - 1));
      if (duration === 1) {
        return startDate.toLocaleDateString(lanCode, {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      }
      return (
        startDate.toLocaleDateString(lanCode, {
          month: "2-digit",
          day: "2-digit",
        }) +
        " - " +
        endDate.toLocaleDateString(lanCode, {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      );
    },
    // Handles keyboard activation for the language selector divs
    handleKeydown(event, locale) {
      // Check for "Enter" or "Space" key
      if (event.key === "Enter" || event.key === " ") {
        this.$i18n.locale = locale;
        event.preventDefault(); // Prevent scrolling on "Space"
      }
    },
  },
};
</script>
